/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaProgressTag/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaProgressTag({
  children,
  viewPath = "/DesignSystem/TysiaProgress/TysiaProgressTag"
  
}) {
let tagValueData = fromData.useDataFormat({ viewPath,
context: 'tag',
format: fromHelpers.formatTag,
})
  return (<React.Fragment
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 type="grey"
 style="filled"
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="tag"
 format="helpers.js formatTag"
 text={tagValueData}
/>
)}
</TysiaTag>
{children}
</React.Fragment>)
}